/* @flow */
import * as React from "react";
import Theme from "nx-components/Theme";
import Toast from "nexia_mobile/components/Toaster/Toast";
import type { toast } from "nexia_mobile/components/Toaster/Toast";

const styles = {
  root: {
    position: "fixed",
    zIndex: Theme.zIndexLayers.POPUP,
    left: "1em",
    right: "1em",
    bottom: "1em",
    pointerEvents: "none",
  },
};

type State = {
  toasts: {
    // Flow can't have number properties. Technically neither can javascript.
    [id: string]: toast,
  },
};

// eslint-disable-next-line no-use-before-define
let singleton: ?Toaster = null;

const PERSISTENT_REGEX = /(^.{50,}$|device did not respond)/i;

export default class Toaster extends React.Component<{||}, State> {
  state = {
    toasts: {},
  };
  _isMounted: boolean;
  _toastCount: number = 0;

  componentDidMount() {
    singleton = this; // eslint-disable-line consistent-this
    this._isMounted = true;
  }

  componentWillUnmount() {
    singleton = null;
    this._isMounted = false;
  }

  // public ref method
  addMessage(message: string) {
    if (message === "" || typeof message !== "string") {
      return;
    }

    const id = this._toastCount++;
    this.setState(({ toasts }) => ({
      toasts: {
        ...toasts,
        [id]: {
          id,
          message,
          persistent: PERSISTENT_REGEX.test(message),
        },
      },
    }));
  }

  _handleDismissToast = (id: number) => {
    if (!this._isMounted) {
      return;
    }
    const key = id.toString(); // For Flow's sake

    this.setState(({ toasts }) => {
      // eslint-disable-next-line no-unused-vars
      const { [key]: dismissedToast, ...newToasts } = toasts;
      return {
        toasts: newToasts,
      };
    });
  };

  render() {
    const { toasts } = this.state;

    return (
      <div style={styles.root}>
        <Toast toasts={toasts} onDismissToast={this._handleDismissToast} />
      </div>
    );
  }
}

export function addMessage(message: string) {
  if (singleton == null) {
    throw new Error(
      "Attempted to show a toast message without a Toaster mounted"
    );
  } else {
    singleton.addMessage(message);
  }
}



// WEBPACK FOOTER //
// ./src/components/Toaster/index.jsx